import { useEffect, useState } from "react";

/** How far the page moves before its direction counts, so a finger's tremble does not flicker what listens. */
export const SCROLL_SLACK_PX = 8;

/**
 * Whether the page was last scrolled down, away from its top: what the
 * floating button shrinks for (0079). Scrolling back up, or reaching the top,
 * says no. Safari's bounce past either end is no move at all, and neither is
 * the window resizing — Safari's toolbars hiding as the page scrolls change
 * where its end is, so the next move is measured from where the page then is.
 */
export function useScrollingDown(): boolean {
  const [down, setDown] = useState(false);
  useEffect(() => {
    const end = () => Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    let last = window.scrollY;
    const onScroll = () => {
      const now = window.scrollY;
      if (now <= 0) {
        setDown(false);
        last = 0;
        return;
      }
      if (now > end()) return;
      if (Math.abs(now - last) < SCROLL_SLACK_PX) return;
      setDown(now > last);
      last = now;
    };
    const onResize = () => {
      last = Math.min(Math.max(window.scrollY, 0), end());
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
    };
  }, []);
  return down;
}
